import React from "react";
import { Flex, Text, Button, Img, Tooltip } from "@chakra-ui/react";
import { IoMdEye } from "react-icons/io";
import { AiFillEdit } from "react-icons/ai";

const StoreItem = ({ history, store }) => {
  return (
    <Flex
      w={{ base: "100%", md: "48%", lg: "31%" }}
      mx={{ base: 0, md: "20px", lg: "10px" }}
      cursor="pointer"
      _hover={{
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
      }}
      flexDir={"column"}
      alignItems={"center"}
      justifyContent="center"
      mb="20px"
      bg={"white"}
      minH="250px"
      borderRadius="10px"
      overflow={"hidden"}
      position={"relative"}
    >
      {
        !store.active && (
          <Flex
            position='absolute'
            top='0'
            left='0'
            w='100%'
            h='100%'
            bg='gray.500'
            opacity={0.5}
            zIndex={100}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Text
              color='white'
              fontWeight='bold'
            >
              Bloqueado por el administrador
            </Text>
          </Flex>
        )
      }
      <Flex 
        position='absolute'
        top='5px'
        right='5px'
        zIndex={200}
      >
        {
          store.visible ? (
            <Tooltip label="Tienda visible" bg="green.500" color="white">
              <Flex 
                bg="green.500"
                h={"20px"}
                w={"20px"}
                borderRadius="50%"
                boxShadow='lg'
              />
            </Tooltip>
          ) : (
            <Tooltip label="Tienda no visible" bg="red.500" color="white">
              <Flex 
                bg="red.500"
                h={"20px"}
                w={"20px"}
                borderRadius="50%"
                boxShadow='lg'
              />
            </Tooltip>
          )
        }
      </Flex>
    <Flex
        flex={1}
        w="100%"
        maxH="50%"
        justifyContent={'center'}
        alignItems={'center'}
        overflow={'hidden'}
        position={'relative'}
        zIndex={1}
    >
      <Img 
        src={store.banner}
        alt={store.name}
        w="100%"
        h={'100%'}
        objectFit="cover"
        pos={'absolute'}
        top={0}
        zIndex={-1}
      />
      <Img
        src={store.logo}
        alt={store.name}
        w="80px"
        h="80px"
        objectFit="contain"
        background={"white"}
        padding="10px"
        boxShadow='md'
        borderRadius="50%"
        mb={"10px"}
      />
    </Flex>
    <Flex 
        bg={store.color || ' white'}
        flex={1}
        flexDir={"column"}
        justifyContent="center"
        alignItems={"center"}
        w="100%"
    >
      <Text fontSize="1.2em" fontWeight="400" mb="10px">
        {store.name}
      </Text>
      
      <Flex>
        <Tooltip label="Ver tienda" aria-label="Ver tienda">
        <Button
          disabled={!store.active}
          bg='white'
          color={"black"}
          size="sm"
          mr={"10px"}
          boxShadow='md'
          onClick={() => history.push(`/${store.shortName}`)}
        >
          <IoMdEye />
        </Button>
        </Tooltip>
        <Tooltip label="Editar tienda" aria-label="Editar tienda">
        <Button
          disabled={!store.active}
          bg='white'
          color={"black"}
          size="sm"
          boxShadow='md'
          onClick={() => history.push('/admin/edit-store/' + store.shortName)}
        >
          <AiFillEdit />
        </Button>
        </Tooltip>
      </Flex>
    </Flex>
    </Flex>
  );
};

export default StoreItem;
